import { useMedia } from "react-use"

export function useIsDesktop() {
    return useMedia("(min-width: 1024px)")
}
